import produce from 'immer'
import { CardsinstagramAction, CardsinstagramActionTypes } from '../actions/cardsinstagramActions'
import { ApiStatus, ICardsinstagramItem } from '../models'

export const initialCardsinstagramState: ICardsinstagramState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  cardsinstagram: [],
  foundcardsinstagram: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function cardsinstagramReducer(state: ICardsinstagramState = initialCardsinstagramState, action: CardsinstagramAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case CardsinstagramActionTypes.SEARCH_CARDSINSTAGRAM:
        draft.searchString = action.searchOptions.searchString
        break
      case CardsinstagramActionTypes.SEARCHING_CARDSINSTAGRAM:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case CardsinstagramActionTypes.SEARCHING_CARDSINSTAGRAM_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case CardsinstagramActionTypes.FOUND_CARDSINSTAGRAM:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundcardsinstagram.push(...action.payload.cardsinstagram.docs)
          : (draft.foundcardsinstagram = action.payload.cardsinstagram.docs)
        draft.totalDocs = action.payload.cardsinstagram.totalDocs
        break

      case CardsinstagramActionTypes.LOAD_CARDSINSTAGRAM:
      case CardsinstagramActionTypes.LOADING_CARDSINSTAGRAM:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundcardsinstagram = []
        break

      case CardsinstagramActionTypes.LOADING_CARDSINSTAGRAM_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case CardsinstagramActionTypes.LOADED_CARDSINSTAGRAM:
        draft.loadingStatus = ApiStatus.LOADED
        draft.cardsinstagram = action.payload.cardsinstagram.docs
        draft.totalDocs = action.payload.cardsinstagram.totalDocs
        break

      case CardsinstagramActionTypes.ADD_CARDSINSTAGRAM:
      case CardsinstagramActionTypes.ADDING_CARDSINSTAGRAM:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case CardsinstagramActionTypes.ADDING_CARDSINSTAGRAM_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardsinstagramActionTypes.ADDED_CARDSINSTAGRAM:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.cardsinstagram.push(action.payload.cardsinstagram.docs[0])
        if (draft.searchString) draft.foundcardsinstagram.push(action.payload.cardsinstagram.docs[0])
        break

      case CardsinstagramActionTypes.REMOVE_CARDINSTAGRAM:
        draft.cardsinstagram.splice(
          draft.cardsinstagram.findIndex((cardinstagram) => cardinstagram._id === action.payload._id),
          1
        )
        break

      case CardsinstagramActionTypes.SOFT_REMOVE_CARDSINSTAGRAM:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardsinstagramActionTypes.SOFT_REMOVING_CARDSINSTAGRAM:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardsinstagramActionTypes.SOFT_REMOVED_CARDSINSTAGRAM:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardsinstagram.splice(
          draft.cardsinstagram.findIndex((cardinstagram) => cardinstagram._id === action.payload._id),
          1
        )
        break

      case CardsinstagramActionTypes.SOFT_REMOVING_CARDSINSTAGRAM_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardsinstagramActionTypes.EDIT_CARDSINSTAGRAM:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case CardsinstagramActionTypes.EDITING_CARDSINSTAGRAM:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardsinstagramActionTypes.EDITED_CARDSINSTAGRAM:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardsinstagram[draft.cardsinstagram.findIndex((cardinstagram) => cardinstagram._id === action.payload._id)] = action.payload
        draft.foundcardsinstagram[draft.foundcardsinstagram.findIndex((cardinstagram) => cardinstagram._id === action.payload._id)] = action.payload
        break

      case CardsinstagramActionTypes.EDITING_CARDSINSTAGRAM_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ICardsinstagramState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  cardsinstagram: ICardsinstagramItem[]
  foundcardsinstagram: ICardsinstagramItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
